import React, {useState} from 'react';
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js';
import { useTranslation } from "react-i18next";

const SetupForm = () => {
	const stripe = useStripe();
	const elements = useElements();
	const [loading, setLoading] = useState(false);

	const [errorMessage, setErrorMessage] = useState(null);

	const [translation] = useTranslation("translations");

	const handleSubmit = async (event) => {
		event.preventDefault();

		if (!stripe || !elements) {
			return;
		}

		setLoading(true);

		const {error} = await stripe.confirmSetup({
			//`Elements` instance that was used to create the Payment Element
			elements,
				confirmParams: {
					return_url: `${window.location.origin}/settings/saved/`,
				}
		});

		if (error) {
			setErrorMessage(error.message);
		} else {
			// Your customer will be redirected to your `return_url`. For some payment
			// methods like iDEAL, your customer will be redirected to an intermediate
			// site first to authorize the payment, then redirected to the `return_url`.
		}

		setLoading(false);
	};

	return (
	<form onSubmit={handleSubmit}>
		{errorMessage && <div className="mb-3">{errorMessage}</div>}
		
		<PaymentElement />

		<div className="mt-3">
			<button className="btn btn-secondary px-4 py-2" disabled={!stripe}>
				{ (stripe && elements) &&
					<>
						{ !loading &&
							<i className="fa fa-floppy-o" aria-hidden="true"></i>
						}
						<span className={`ms-2 ${loading ? 'me-2' : ''}`}>{translation("save")}</span>
					</>
				}

				{ (!stripe || !elements || loading) &&
					<div className="spinner-border spinner-border-sm" role="status" >
						<span className="visually-hidden">Loading...</span>
					</div>
                }
				
			</button>
		</div>
		
	</form>
	)
};

export default SetupForm;